import React from 'react'
import { FormSelectField } from '@/components/Form/FormField'
import { Button } from '@/components/ui/button'
import { DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { TickmillCompanyDto } from 'api/Identity/Types/Company'
import { IntroducingBrokerReferralRestrictionDto } from 'api/Trading-Accounts/Types/IntroducingBrokerReferralRestrictionDto'
import { Form, FormikErrors, FormikProps, withFormik } from 'formik'
import { FormSubmitValues } from 'utils/formValidation'

export interface AddEditIBReferralRestrictionFormValues {
  tickmillCompanyId: number
}

const AddEditIBReferralRestrictionFormUI: React.FC<
  FormikProps<AddEditIBReferralRestrictionFormValues> & OuterProps
> = (props) => {
  const { isSubmitting, errors, handleSubmit, setFieldValue, tickmillCompanies, values } = props

  return (
    <DialogContent size='sm' render={<Form />}>
      <DialogHeader>
        <DialogTitle>
          {props.entity ? 'Edit Referral Restriction' : 'Add Referral Restriction'}
        </DialogTitle>
      </DialogHeader>
      <FormSelectField
        name='tickmillCompanyId'
        label='Tickmill Company'
        options={tickmillCompanies}
        value={values.tickmillCompanyId}
        allowClear
        showSearch
        error={errors.tickmillCompanyId}
        onChange={(value) => setFieldValue('tickmillCompanyId', value)}
      />
      <DialogFooter>
        <Button disabled={isSubmitting} type='button' onClick={() => handleSubmit()}>
          Submit
        </Button>
      </DialogFooter>
    </DialogContent>
  )
}

interface OuterProps {
  entity?: IntroducingBrokerReferralRestrictionDto
  tickmillCompanies: TickmillCompanyDto[]

  onSubmit(values: FormSubmitValues<AddEditIBReferralRestrictionFormValues>): Promise<void>
}

function dataToSubmit(
  values: AddEditIBReferralRestrictionFormValues
): FormSubmitValues<AddEditIBReferralRestrictionFormValues> {
  return {
    ...values,
  }
}

export const AddEditIBReferralRestrictionForm = withFormik<
  OuterProps,
  AddEditIBReferralRestrictionFormValues
>({
  mapPropsToValues: ({ entity }) => {
    const currentEntity: Partial<IntroducingBrokerReferralRestrictionDto> = entity || {}
    return {
      tickmillCompanyId: currentEntity?.tickmillCompany?.id || 0,
    }
  },
  handleSubmit: async (values, { props, setSubmitting }) => {
    try {
      await props.onSubmit(dataToSubmit(values))
    } finally {
      setSubmitting(false)
    }
  },
  validate: (values) => {
    const errors: FormikErrors<AddEditIBReferralRestrictionFormValues> = {}
    if (!values.tickmillCompanyId) {
      errors.tickmillCompanyId = 'required'
    }
    return errors
  },
  enableReinitialize: true,
})(AddEditIBReferralRestrictionFormUI)
